var aiVRecomUrl = 'https://cdn.jsdelivr.net/npm/@algolia/recommend@4.20.0/dist/recommend.umd.min.js';
var aiVRecomInput = '';
var aiVRecomMax = 20;
if(recommend_RelatedId && recommend_RelatedId > 0){
  aiVRecomInput = [
    {
      indexName: 'hemm_products',
      objectID: recommend_RelatedId,
      maxRecommendations: aiVRecomMax
    },
  ]
}
async function aiVRecomRender(aiVRecomPara) {
  var aiVRecomSectUrl = main_globlang_pref + '/pages/contact/';
  var aiRecomAppend = await fetch(aiVRecomSectUrl + aiVRecomPara + '/?sections=recommend-related')
  .then(response => response.json())
  .then(data => { 
    $('#recommend-related-section').html(data["recommend-related"]);
  });
}
function aiVRecomDisp(aiVRecomRes){
  var aiVRecomParam = '';
  $.each(aiVRecomRes, function(index,aiVRecomItem){
    if(aiVRecomItem['handle']){
      aiVRecomItemHandle = aiVRecomItem['handle'].replaceAll('/', '-');
      aiVRecomParam += aiVRecomItemHandle + '_';
    }
  });
  $(document).ready(function () {
    aiVRecomRender(aiVRecomParam);
  });
}
if(aiVRecomInput != ''){
  $.getScript(aiVRecomUrl, function() {
    const aiVRecom = window['@algolia/recommend'];
    const aiVRecomClient = aiVRecom('K4GLX02XDN', '8990032a777c331ea8907b1e4fe6f034');
    aiVRecomClient.getLookingSimilar(aiVRecomInput)
    .then(({ results }) => {
      if(results && results[0] && results[0].hits && results[0].hits.length > 0){
        aiVRecomDisp(results[0].hits);
        $('.related-block').css('min-height','350px');
      }
    })
    .catch(err => {
      console.log(err);
    });
  });
}